<label
    [ngClass]="{
        'border-gray': !isSelected(item),
        'border-transparent': isSelected(item),
    }"
  class="relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none"
  >
  <input
    type="radio"
    name="delivery-method"
    [value]="getItemId(item)"
    class="sr-only"
    (focus)="setFocussedId(item)"
    (blur)="setFocussedId(undefined)"
    (change)="selectChanged(item)"
    />

  <div class="absolute left-3 top-5 w-5 h-5 flex items-center justify-center">
    @if (isSelected(item)) {
      <div
        class="w-3 h-3 rounded-full bg-accent flex items-center justify-center"
        >
        <div class="w-1 h-1 rounded-full bg-white"></div>
      </div>
    }

    @if (!isSelected(item)) {
      <div
        class="w-3 h-3 rounded-full border border-gray-300"
      ></div>
    }
  </div>

  <div class="flex-1 flex">
    <div class="flex ml-6 w-full flex-col pointer-events-none">
      <ng-content></ng-content>
    </div>
  </div>
  <div
        [ngClass]="{
            'border-transparent': !isSelected(item),
            'border-accent': isSelected(item)
        }"
    class="absolute -inset-px rounded-lg border-2 pointer-events-none"
    aria-hidden="true"
  ></div>
</label>
